$('a[href^="#"]').click(function(){
	let speed = 500;
	let href= $(this).attr("href");
	let target = $(href == "#" || href == "" ? 'html' : href);
	let distance = 65;
	let position = target.offset().top - distance;
	$("html, body").animate({scrollTop:position}, speed, "swing");
	return false;
});
